import { useQueryClient } from '@tanstack/react-query';
import { type FileAsset, type FolderAsset, FolderType, createFileAsset, createFolderAsset } from 'models';
import { useMutation } from 'query';
import { updateAsset } from '../../services';
import { assetsFeatureKey } from '../keys';

export const useUpdateAssetMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<FileAsset | FolderAsset, { id: string; name?: string; parentId?: string }>({
    async mutationFn({ id, name, parentId }) {
      const response = await updateAsset({
        /* eslint-disable @typescript-eslint/naming-convention -- Start: key is defined by Backend API endpoint */
        body: { name, parent_id: parentId },
        /* eslint-enable @typescript-eslint/naming-convention -- End: key is defined by Backend API endpoint */
        routeParams: { id },
      });

      return response.data.type === FolderType ? createFolderAsset(response.data) : createFileAsset(response.data);
    },
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: assetsFeatureKey });
    },
  });
};
